import { useEffect, useState } from 'react'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import styled, { keyframes } from 'styled-components'

export const ActiveStaffMarqueeComponent = ({
  animation = true,
  apiSignature = '/api/secure/doctor/get-active-staff-details',
  dataRefreshFrequencySeconds = 180,
  containerStylesOverride,
}) => {
  const [checkedInScreeners, setCheckedInScreeners] = useState([])
  const [checkedInTherapists, setCheckedInTherapists] = useState([])

  async function getAndSetData() {
    if (getAllRolesInBoolean().isDoctor) {
      try {
        const response = await getDataWithParams(apiSignature, {})
        if (
          response?.status === 200 &&
          isCommonResponseSuccessfulV2(response) &&
          Array.isArray(response?.data?.data?.checkedInScreeners) &&
          Array.isArray(response?.data?.data?.checkedInTherapists)
        ) {
          setCheckedInScreeners(response?.data?.data?.checkedInScreeners)
          setCheckedInTherapists(response?.data?.data?.checkedInTherapists)
        }
      } catch (error) {
        console.error('Error fetching active staff details:', error)
      }
    }
  }

  useEffect(() => {
    getAndSetData() // Initial fetch

    const intervalId = setInterval(() => {
      getAndSetData()
    }, dataRefreshFrequencySeconds * 1000)

    return () => clearInterval(intervalId) // Cleanup on unmount
  }, [apiSignature, dataRefreshFrequencySeconds])

  // console.log(checkedInScreeners) // Removed to prevent loop logging
  // console.log(checkedInTherapists) // Removed to prevent loop logging

  const allStaff = removeDuplicatesFromStaffList([...checkedInScreeners, ...checkedInTherapists])

  if (checkedInScreeners?.length === 0 && checkedInTherapists?.length === 0) {
    return <></>
  }

  return (
    <div
      style={{
        background: '#e0ccfc',
        color: '#000',
        fontSize: '12px',
        padding: '2px 4px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        borderRadius: '4px',
        gap: '8px',
        ...containerStylesOverride,
      }}
      className='hide-on-print-only'
    >
      {'Therapist available'}
      <BlinkingRedDot />
      {allStaff?.map((item, idx) => {
        return (
          <span key={idx}>
            {item?.teacherName} ({item?.chamberRoomName})
          </span>
        )
      })}
      {/* <BlinkingRedDot /> */}
    </div>
  )
}

function removeDuplicatesFromStaffList(arr) {
  const seenTeacherIds = new Set()

  return arr.filter((item) => {
    if (seenTeacherIds.has(item.teacherId)) {
      return false
    } else {
      seenTeacherIds.add(item.teacherId)
      return true
    }
  })
}

// Create a keyframe for the blinking animation
const blinkAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

// Styled component for the blinking red dot
const BlinkingRedDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
  animation: ${blinkAnimation} 2s infinite;
`
